import React, { Component } from 'react';
import LoadingOverlay from '../loading/loading';
import { toast } from "react-toastify";
import service from '../../services/service';  // Import API service

class BankDetailForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userId: "",
            accountHolderName: "",
            mobileNo: "",
            bankAccountNumber: "",
            bankName: "",
            ifscCode: "",
            loading: false,
            updateFields: {},
            withdrawalAmount: 0,
            password: "",
            upiId: "",
        };
    }

    componentDidMount() {
        this.getBankDetailsByUserID();
    }

    getBankDetailsByUserID = async () => {
        this.setState({ loading: true });
        try {
            const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';
            if (isLoggedIn) {
                const userId =
                    sessionStorage.getItem('isAdmin') === 'true' && this.props.userID
                        ? this.props.userID
                        : sessionStorage.getItem('userId');
                const response = await service.view(`bankDetails/user/${userId}`);
                if (response.success && response.data) {
                    const bankDetail = response.data;
                    this.setState({
                        userId: bankDetail.userId,
                        accountHolderName: bankDetail.accountHolderName,
                        mobileNo: bankDetail.mobileNo,
                        bankAccountNumber: bankDetail.bankAccountNumber,
                        bankName: bankDetail.bankName,
                        ifscCode: bankDetail.ifscCode,
                        upiId: bankDetail.upiId,
                    });
                }
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            this.setState({ loading: false });
        }
    };


    changeHandler = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
        this.setState((prevState) => ({
            updateFields: {
                ...prevState.updateFields,
                [name]: value,
            },
        }));
    };

    submitHandler = async (e) => {
        e.preventDefault();
        try {
            this.setState({ loading: true });
            const userId =
                sessionStorage.getItem('isAdmin') === 'true' && this.props.userID
                    ? this.props.userID
                    : sessionStorage.getItem('userId');
            const response = await service.save(this.state.updateFields, `bankDetails/save/${userId}`, "PUT");
            if (!response.success) {
                toast.error(response.error);
                return;
            }
            toast.success("Bank details updated successfully!");
        } catch (error) {
            toast.error(error.message);
        } finally {
            this.setState({ loading: false });
        }
    };

    submitWithdrawlHandler = async (e) => {
        e.preventDefault();
        try {
            this.setState({ loading: true });
            const response = await service.save({
                userId: sessionStorage.getItem('userId'),
                amount: this.state.withdrawalAmount,
                password: this.state.password
            }, `wallet/withdraw`, "POST");

            if (!response.success) {
                toast.error(response.message);
                return;
            }
            toast.success("Withdrawal request submitted successfully.");
        } catch (error) {
            toast.error(error.message);
        } finally {
            this.setState({ loading: false });
        }
    }

    render() {
        const { accountHolderName, mobileNo, bankAccountNumber, bankName, ifscCode, loading, withdrawalAmount, password, upiId } = this.state;

        return (
            <>
                {loading && <LoadingOverlay />}
                <form onSubmit={this.submitHandler} className="contact-form">
                    <div className="row">
                        <div className="col-lg-4 col-12">
                            <div className="form-field">
                                <label className="form-label">Account Holder Name</label>
                                <input
                                    style={{ color: 'black' }}
                                    value={accountHolderName}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="accountHolderName"
                                    placeholder="Enter account holder name"
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="form-field">
                                <label className="form-label">Mobile Number</label>
                                <input
                                    style={{ color: 'black' }}
                                    value={mobileNo}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="mobileNo"
                                    placeholder="Enter mobile number"
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="form-field">
                                <label className="form-label">Bank Account Number</label>
                                <input
                                    style={{ color: 'black' }}
                                    value={bankAccountNumber}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="bankAccountNumber"
                                    placeholder="Enter bank account number"
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="form-field">
                                <label className="form-label">Bank Name</label>
                                <input
                                    style={{ color: 'black' }}
                                    value={bankName}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="bankName"
                                    placeholder="Enter bank name"
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="form-field">
                                <label className="form-label">IFSC Code</label>
                                <input
                                    style={{ color: 'black' }}
                                    value={ifscCode}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="ifscCode"
                                    placeholder="Enter IFSC code"
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="form-field">
                                <label className="form-label">UPI Code</label>
                                <input
                                    style={{ color: 'black' }}
                                    value={upiId}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="upiId"
                                    placeholder="Enter UPI ID"
                                />
                            </div>
                        </div>
                        <div className="col-lg-12 col-12 text-end">
                            <div className="form-field">
                                <button type="submit" className="theme-btn" style={{ padding: '10px 40px', marginTop: '30px' }}>Update</button>
                            </div>
                        </div>
                    </div>
                </form>

                <hr />
                <h5 className='text-center'>Withdrawal Information</h5>
                <form onSubmit={this.submitWithdrawlHandler} className="contact-form mt-4">
                    <div className="row">
                        <div className="col-lg-4 col-12">
                            <div className="form-field">
                                <label className="form-label">Withdrawal Amount</label>
                                <input
                                    style={{ color: 'black' }}
                                    value={withdrawalAmount}
                                    onChange={(e) => this.setState({ withdrawalAmount: e.target.value.replace(/\D/g, '') })}
                                    type="text"
                                    name="withdrawalAmount"
                                    placeholder="xxxxxxxx"
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="form-field">
                                <label className="form-label">Password</label>
                                <input
                                    style={{ color: 'black' }}
                                    value={password}
                                    onChange={(e) => this.setState({ password: e.target.value })}
                                    type="text"
                                    name="Password"
                                    placeholder="********"
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12 text-end">
                            <div className="form-field">
                                <button type="submit" className="theme-btn" style={{ padding: '10px 40px', marginTop: '30px' }}>Send</button>
                            </div>
                        </div>
                    </div>
                </form>
            </>
        );
    }
}

export default BankDetailForm;
